/**
 * Prazo para uma leitura de rede que pode PENDURAR sem rejeitar (BUG-234).
 *
 * O transporte do Firestore reconectando depois do bloqueio de tela (classe
 * BUG-179/196) não rejeita — fica em silêncio. Uma recuperação que só reage a
 * rejeição espera para sempre, e o app fica sem o modal de uma sessão viva.
 * Puro: a rejeição por prazo é uma `Error` comum, então quem já trata falha
 * de rede trata o prazo de graça.
 */

/** Mesmo teto do `useFocusTimer` (`RECOVER_TIMEOUT_MS`): 8 s. */
export const FOCUS_RECOVER_READ_TIMEOUT_MS = 8_000;

export class TimeoutError extends Error {
  constructor(label: string, ms: number) {
    super(`${label}: sem resposta em ${ms} ms`);
    this.name = "TimeoutError";
  }
}

export function withTimeout<T>(promise: Promise<T>, ms: number, label: string): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const prazo = new Promise<never>((_, reject) => {
    timer = setTimeout(() => reject(new TimeoutError(label, ms)), ms);
  });
  return Promise.race([promise, prazo]).finally(() => {
    if (timer != null) clearTimeout(timer);
  });
}
